import React, { createRef, useContext, useEffect } from "react";

import MapService from "common/services/Map";
import MapSearch from "common/components/Map/MapSearch";
import Map from "common/components/Map/Map";
import MapContext from "common/contexts/map-context";
import BasicButton from "common/components/Widgets/BasicButton/BasicButton";
import ApiRequests from "common/services/ApiRequests";
import StateContext from "common/contexts/state-context";
import TrackingService from "common/services/Tracking/Tracking";
import "./HomeSearch.css";
import HeroBanner from "../HeroBanner/HeroBanner";
import { ButtonBasicStyle } from "../../../GlobalValues";

const HomeSearch = (props) => {
  const [state, setState] = useContext(StateContext);
  const [map, setMap] = useContext(MapContext);
  const searchBarRef = createRef();
  const { placeLoc } = state?.sl?.settings;
  const { isLocationPage } = props;

  useEffect(() => {
    if (props.withGoTo && searchBarRef.current) {
      searchBarRef.current.scrollIntoView(true);
    }
  });

  useEffect(() => {
    TrackingService.pageView("storelocator");
    if (placeLoc) {
      TrackingService.trackSearchedPlace();
    }
  }, [placeLoc]);

  const goToGeolocation = async () => {
    const geoLocInfos = await MapService.goToGeolocation();
    const newState = await ApiRequests.getBrands(geoLocInfos.pagination, state);

    // Get reverse geocoding data for HeroBanner
    if (geoLocInfos.pagination.from_lat && geoLocInfos.pagination.from_lng) {
      try {
        const reverseGeocoding =
          await MapService.geoapifyService.getReverseGeocoding(
            geoLocInfos.pagination.from_lat,
            geoLocInfos.pagination.from_lng,
          );
        if (reverseGeocoding.length > 0 && newState.sl) {
          newState.sl.autocompleteData = reverseGeocoding[0];
        }
      } catch (error) {
        console.warn("Error getting reverse geocoding:", error);
      }
    }

    setState(newState);
    setMap({
      ...map,
      placeId: geoLocInfos.placeId,
      placeLoc: {
        ...map.placeLoc,
        lat: geoLocInfos.pagination.from_lat,
        lng: geoLocInfos.pagination.from_lng,
      },
    });
  };

  return (
    <React.Fragment>
      <Map mapSize={{ height: "0", width: "0" }} />
      <HeroBanner isLocationPage={isLocationPage} />
      {state.sl.home_search && (
        <div className="sl-bg-primary sl-flex sl-flex-col sl-gutter-m sl-jc-center hs-container">
          <div
            className="sl-bg-tertiary sl-flex sl-flex-col sl-gutter-l sl-gap-l sl-jc-center sl-ai-center maw-w-500-desk"
            style={{
              border: "1px solid var(--secondary-color)",
              borderRadius: "var(--b-radius)",
            }}
          >
            <div className="sl-flex sl-flex-col sl-jc-center sl-ai-center sl-text-center sl-gap-s">
              <p className="sl-title-bloc sl-title">Trouvez un salon Vog</p>
              <p className="sl-title sl-text-m">proche de chez vous</p>
            </div>
            <div className="sl-flex  sl-ai-center map-search-container">
              <MapSearch
                input={{
                  placeholder: "Ville ou code postal",
                  style: {
                    height: "30px",
                    padding: "var(--gutter-m)",
                    border: "1px solid var(--secondary-color)",
                    borderRadius: "25px",
                    position: "relative",
                  },
                }}
                predictionsSelect={{
                  wrapper: {
                    style: {
                      zIndex: 1,
                    },
                  },
                }}
                button={{
                  style: {
                    position: "absolute",
                    top: "50%",
                    right: "5px",
                    transform: "translateY(-50%)",
                    borderRadius: "20px",
                    backgroundColor: "transparent",
                    color: "var(--secondary-color)",
                    letterSpacing: "2px",
                    width: "fit-content",
                  },
                }}
              />

              <p className="sl-text-small sl-text-bold">OU</p>
              <BasicButton
                label="Localisez-moi"
                hover={"var(--primary-color"}
                style={{
                  ...ButtonBasicStyle,
                  backgroundColor: "var(--secondary-color)",
                  color: "var(--tertiary-color)",
                }}
                onClick={() => goToGeolocation()}
              />
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default HomeSearch;
